import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import app from './modules/app'
import getters from './getters'
import file from './modules/file'
import customer from './modules/customer'
import lawcase from './modules/lawcase'
import contract from './modules/contract'


Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		app,
		permission,
		file,
		user,
		customer,
		lawcase,
		contract
	},
	getters
})

export default store